<template>
  <el-dialog
    title="新增费用项目"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <el-form
      :model="createForm"
      :rules="rules"
      ref="createForm"
      label-width="180px"
      size="small"
    >
      <!-- 收费项 -->
      <el-form-item label="收费项：" prop="price_name">
        <el-input v-model="createForm.price_name" placeholder="请输入收费项"></el-input>
      </el-form-item>

      <!-- 交付批次 -->
      <el-form-item label="交付批次：" prop="delivery_name">
        <el-input v-model="createForm.delivery_name" placeholder="请输入交付批次"></el-input>
      </el-form-item>

      <!-- 数量 -->
      <el-form-item label="数量：" prop="item_count">
        <el-input
          v-model="createForm.item_count"
          type="number"
          min="1"
          placeholder="请输入数量"
        ></el-input>
      </el-form-item>

      
      <!-- 单价 -->
      <el-form-item label="单价（元）：" prop="unit_price">
        <el-input
          v-model="createForm.unit_price"
          type="number"
          step="0.01"
          placeholder="请输入单价"
        ></el-input>
      </el-form-item>
      <!-- 计量单位 -->
      <el-form-item label="单位：" prop="metering_unit">
        <el-select v-model="createForm.metering_unit" placeholder="请选择单位" style="width: 100%;">
          <el-option label="台·日" :value="1"></el-option>
          <el-option label="卡·时" :value="2"></el-option>
          <el-option label="T·月" :value="3"></el-option>
          <el-option label="台·月" :value="4"></el-option>
        </el-select>
      </el-form-item>

      <!-- 总金额 -->
      <el-form-item label="金额（元）：" prop="total_amount">
        <el-input
          v-model="createForm.total_amount"
          type="number"
          step="0.01"
          placeholder="请输入金额"
        ></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="createForm.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
        />
      </el-form-item>

      


      <!-- 交付时间（限制不能超过账单周期结束时间） -->
      <!-- <el-form-item label="交付时间：" prop="delivery_time">
        <el-date-picker
          v-model="createForm.delivery_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择交付时间"
          style="width: 100%;"
          :picker-options="deliveryTimePickerOptions"
        ></el-date-picker>
      </el-form-item> -->

    </el-form>

    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateOtherDeliveryItem',
  props: {
    billId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      maxDeliveryDate: '', // 存储账单周期结束时间，格式为 '2025-06-05 23:59:59'

      createForm: {
        bill_id: '',
        price_name: '',
        delivery_name: '',
        item_count: 1,
        metering_unit: 1,
        unit_price: '',
        total_amount: '',
        remark: ''
        // delivery_time: ''
      },
      rules: {
        price_name: [
          { required: true, message: '请输入收费项', trigger: 'blur' }
        ],
        item_count: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = Number(value);
              if (isNaN(num) || num < 1) {
                callback(new Error('数量必须大于等于1'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        metering_unit: [
          { required: true, message: '请选择计量单位', trigger: 'change' }
        ],
        unit_price: [
          { required: true, message: '请输入单价', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = Number(value);
              if (isNaN(num) || num < 0) {
                callback(new Error('单价必须为非负数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        
        total_amount: [
          { required: true, message: '金额不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const str = String(value).trim();

              // 再次检查空值
              if (!str) {
                return callback(new Error('金额不能为空'));
              }

              // 支持负数、正数、零，最多两位小数
              // 例如：123, -123.45, 0.01, -0.01, 0.1, .5（可选支持）等
              const moneyPattern = /^-?(0|[1-9]\d*)(\.\d{1,2})?$/;

              if (!moneyPattern.test(str)) {
                return callback(new Error('请输入有效金额，最多保留两位小数（可为负数）'));
              }

              callback();
            },
            trigger: 'blur'
          }
        ]
        // delivery_time: [
        //   { required: true, message: '请选择交付时间', trigger: 'change' },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value && this.maxDeliveryDate && new Date(value) > new Date(this.maxDeliveryDate)) {
        //         const displayDate = this.formatDate(this.maxDeliveryDate);
        //         callback(new Error(`交付时间不能晚于账单周期结束时间：${displayDate}`));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'change'
        //   }
        // ]
      }
    };
  },
  computed: {
    // 限制交付时间选择器的最大可选时间
    deliveryTimePickerOptions() {
      const maxTime = this.maxDeliveryDate ? new Date(this.maxDeliveryDate) : null;
      return {
        disabledDate: (time) => {
          return maxTime ? time.getTime() > maxTime.getTime() : false;
        }
      };
    }
  },
  methods: {
    /**
     * 打开弹窗，接收 billId 和 settlementPeriod
     * @param {String} billId
     * @param {String} settlementPeriod 格式如 "2025/05/05 至 2025/06/05"
     */
    openDialog(billId, settlementPeriod) {
      this.createForm.bill_id = billId || this.billId;

      // 解析账单周期，提取结束时间
      if (settlementPeriod && settlementPeriod.includes(' 至 ')) {
        const parts = settlementPeriod.split(' 至 ');
        const endDate = parts[1]; // "2025/06/05"
        // 转为 YYYY-MM-DD HH:mm:ss 格式，设为当天最后一秒
        this.maxDeliveryDate = endDate.replace(/\//g, '-') + ' 23:59:59';
      } else {
        // 如果没有传入，不限制（或设默认值）
        this.maxDeliveryDate = '';
      }

      this.dialogVisible = true;

      // 使用 $nextTick 确保 DOM 更新后再重置表单
      this.$nextTick(() => {
        this.$refs.createForm.resetFields();
        // 重新设置 bill_id（resetFields 会清空）
        this.createForm.bill_id = billId || this.billId;
      });
    },

    // 重置表单
    resetForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields();
      }
    },

    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return;
        }

        // 可在此添加额外逻辑，如时间顺序校验
        const deliveryTime = new Date(this.createForm.delivery_time);

        const postData = { ...this.createForm };

        // 发送请求
        this.$axios
          .post('/api-30216/api/bill-other-items', postData)
          .then(res => {
            if (res.code === 200) {
              this.$message.success('新增成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新
            } else {
              this.$message.error(res.message || '新增失败');
            }
          })
          .catch(err => {
            this.$message.error('请求失败，请检查网络');
            console.error(err);
          });
      });
    },

    // 格式化日期用于提示（如 2025/06/05）
    formatDate(dateStr) {
      return dateStr ? dateStr.slice(0, 10).replace(/-/g, '/') : '';
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
</style>